export const ERROR_CODES = {
  BAD_REQUEST: 'BAD_REQUEST_ERROR',
  GENERIC: 'GENERIC_ERROR',
  NO_CONTENT: 'NO_CONTENT_ERROR',
  GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR_ERROR',
  UNAVAILABLE_FOR_LEGAL_REASONS: 'UNAVAILABLE_FOR_LEGAL_REASONS_ERROR',
  UNPROCESSABLE_CONTENT: 'UNPROCESSABLE_CONTENT_ERROR'
}
